import React, { useState } from 'react';
import './HelpSupport.css'; // Import the CSS file

const HelpSupport = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here (e.g., sending data to backend)
        console.log('Form submitted:', formData);
    };

    return (
        <div className="help-support-container">
            <h2>Help & Support</h2>

            {/* FAQ Section */}
            <div className="faq-section">
            <h3>Frequently Asked Questions</h3>
<div className="faq-item">
    <h4>What is Vainivyah ?</h4>
    <p>Vainivyah Botic is an AI-powered application designed to provide intelligent solutions for your needs, including managing bookings, generating recommendations, and streamlining user interactions.</p>
</div>
<div className="faq-item">
    <h4>How do I create an account on Vainivyah ?</h4>
    <p>You can create an account by clicking on the "Sign Up" button on the homepage and filling out your details. You can also sign up using your Google or Facebook account.</p>
</div>
<div className="faq-item">
    <h4>How do I book a service or product?</h4>
    <p>Select the desired service or product from the catalog, customize your options if applicable, and proceed to the checkout to confirm your booking.</p>
</div>
<div className="faq-item">
    <h4>How can I cancel a booking?</h4>
    <p>To cancel a booking, go to the "My Bookings" section, select the booking you wish to cancel, and click on the "Cancel" button. Cancellation policies may apply.</p>
</div>
<div className="faq-item">
    <h4>What payment methods does Vainivyah Botic support?</h4>
    <p>We accept payments via credit/debit cards, UPI, net banking, and digital wallets such as PayPal, Google Pay, and Paytm.</p>
</div>
<div className="faq-item">
    <h4>Can I reschedule a booking?</h4>
    <p>Yes, you can reschedule bookings from the "My Bookings" section, provided the service allows rescheduling. Additional charges may apply.</p>
</div>
<div className="faq-item">
    <h4>How do I contact customer support?</h4>
    <p>You can reach our customer support team via the "Help Center" section in the app or by emailing us at support@vainivyah.com.</p>
</div>
<div className="faq-item">
    <h4>Is there a mobile app for Vainivyah ?</h4>
    <p>Yes, the Vainivyah  app is available for download on both Android and iOS platforms. Search for "Vainivyah" in the app store to download.</p>
</div>
<div className="faq-item">
    <h4>How can I update my profile details?</h4>
    <p>Go to the "Profile" section in the app, where you can edit your personal details, including name, email, and phone number.</p>
</div>
<div className="faq-item">
    <h4>What should I do if I encounter a technical issue?</h4>
    <p>If you experience any technical problems, please report the issue via the "Help Center" in the app or contact our support team for assistance.</p>
</div>
</div>


            {/* Contact Form Section */}
            <div className="contact-form-section">
                <h3>Contact Us</h3>
                <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-group">
                        <label htmlFor="name">Your Name</label>
                        <input 
                            type="text" 
                            id="name" 
                            name="name" 
                            value={formData.name} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input 
                            type="email" 
                            id="email" 
                            name="email" 
                            value={formData.email} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea 
                            id="message" 
                            name="message" 
                            rows="5" 
                            value={formData.message} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>
                    <button type="submit" className="submit-button" style={{backgroundColor:"#3A1A1D"}}>Submit</button>
                </form>
            </div>
        </div>
    );
};

export default HelpSupport;
